export const GET_READY_PRODUCTS = 'GET_READY_PRODUCTS';
export const GET_READY_PRODUCTS_SUCCESS = 'GET_READY_PRODUCTS_SUCCESS';
export const GET_READY_PRODUCTS_FAIL = 'GET_READY_PRODUCTS_FAIL';
export const DELETE_READY_PRODUCTS = 'DELETE_READY_PRODUCTS';
export const DELETE_READY_PRODUCTS_SUCCESS = 'DELETE_READY_PRODUCTS_SUCCESS';
export const DELETE_READY_PRODUCTS_FAIL = 'DELETE_READY_PRODUCTS_FAIL';
export const DELETE_READY_PRODUCTS_MULTIPLE = 'DELETE_READY_PRODUCTS_MULTIPLE';
export const DELETE_READY_PRODUCTS_MULTIPLE_SUCCESS = 'DELETE_READY_PRODUCTS_MULTIPLE_SUCCESS';
export const DELETE_READY_PRODUCTS_MULTIPLE_FAIL = 'DELETE_READY_PRODUCTS_MULTIPLE_FAIL';

export const SEND_FOR_MOUNTING = 'SEND_FOR_MOUNTING';
export const SEND_FOR_MOUNTING_SUCCESS = 'SEND_FOR_MOUNTING_SUCCESS';
export const SEND_FOR_MOUNTING_FAIL = 'SEND_FOR_MOUNTING_FAIL';
